/** @jsxImportSource @emotion/react */

import { AliChangeResponse } from "services/DiscrepancyType";
import tw from "twin.macro";
import { formatHouseNumber, formatPhoneNumber } from "utils/helpers";

export const ChangeRequestTable: React.FC<AliChangeResponse> = ({
  ali,
  ali_change,
}) => {
  console.log(ali, ali_change);

  const normalizeComparableValue = (value: unknown) =>
    value == null || value === "" ? "" : value;

  const aliChangeData = [
    {
      key: "Customer Name",
      original: ali_change.ORG_NAM,
      requested: ali_change.EDIT_NAM,
      current: ali && ali.NAM,
    },
    {
      key: "House Number",
      original: ali_change.ORG_HNO,
      requested: ali_change.EDIT_HNO,
      current: ali && formatHouseNumber(ali, ali.HNO),
    },
    {
      key: "House Number Suffix",
      original: ali_change.ORG_HNS,
      requested: ali_change.EDIT_HNS,
      current: ali && ali.HNS,
    },
    {
      key: "Prefix Directional",
      original: ali_change.ORG_PRD,
      requested: ali_change.EDIT_PRD,
      current: ali && ali.PRD,
    },
    {
      key: "Street Name",
      original: ali_change.ORG_STN,
      requested: ali_change.EDIT_STN,
      current: ali && ali.STN,
    },
    {
      key: "Street Suffix",
      original: ali_change.ORG_STS,
      requested: ali_change.EDIT_STS,
      current: ali && ali.STS,
    },
    {
      key: "Post Directional",
      original: ali_change.ORG_POD,
      requested: ali_change.EDIT_POD,
      current: ali && ali.POD,
    },
    {
      key: "MSAG Community Name",
      original: ali_change.ORG_MCN,
      requested: ali_change.EDIT_MCN,
      current: ali && ali.MCN,
    },
    {
      key: "State",
      original: ali_change.ORG_STA,
      requested: ali_change.EDIT_STA,
      current: ali && ali.STA,
    },
    {
      key: "Location",
      original: ali_change.ORG_LOC,
      requested: ali_change.EDIT_LOC,
      current: ali && ali.LOC,
    },
    {
      key: "Comments",
      original: ali_change.ORG_Comments,
      requested: ali_change.EDIT_Comments,
      current: ali && ali.Comments,
    },
  ];

  return (
    <>
      <div css={[tw`flex justify-between items-center`]}>
        <h3>
          Changes to {formatPhoneNumber(ali_change.CPN)} {ali && `(${ali.NAM})`}
        </h3>
      </div>

      <div
        css={[
          tw`col-span-2 overflow-hidden min-h-full border border-gray-400 rounded-md`,
        ]}
      >
        <table css={[tw`w-full`]}>
          <thead css={[tw`bg-gray-200 border-b border-gray-400`]}>
            <tr css={[tw`text-left`]}>
              <th css={[tw`border-r border-gray-400 p-2`]}></th>
              <th css={[tw`font-semibold border-r border-gray-400 p-2`]}>
                Original
              </th>
              <th css={[tw`border-r border-gray-400 font-semibold p-2`]}>
                Requested
              </th>
              <th css={[tw`font-semibold p-2`]}>Current</th>
            </tr>
          </thead>
          <tbody>
            {aliChangeData.map((row) => (
              <tr
                key={row.key}
                css={[
                  tw`border-b border-gray-300`,
                  (normalizeComparableValue(row.original) !==
                    normalizeComparableValue(row.requested) ||
                    normalizeComparableValue(row.current) !==
                      normalizeComparableValue(row.requested) ||
                    normalizeComparableValue(row.original) !==
                      normalizeComparableValue(row.current)) &&
                    tw`bg-yellow-600`,
                ]}
              >
                <td
                  css={[tw`font-semibold border-r border-gray-400 p-2 w-1/4`]}
                >
                  {row.key}
                </td>
                <td css={[tw`border-r border-gray-400 p-2 w-1/4`]}>
                  {row.original}
                </td>
                <td css={[tw`border-r border-gray-400 p-2 w-1/4`]}>
                  {row.requested}
                </td>
                <td css={[tw`p-2 w-1/4`]}>{row.current}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
